<template>
  <div class="course-box">
    <div class="Breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="is-l" :to="{ path: '/FirmManagement' }"
          >实盘管理</el-breadcrumb-item
        >
        <el-breadcrumb-item class="is-l" :to="{ path: '/NewlyIncreased' }"
          >新增实盘</el-breadcrumb-item
        >
        <el-breadcrumb-item>绑定API Key教程</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bourse-container">
      <el-container>
        <el-aside class="side-nav" width="240px">
          <div class="sidebar-bnt">
            <el-radio-group
              v-model="bourseRadio"
              size="medium"
              @change="BybitClick"
            >
              <el-radio-button label="Bybit 绑定API Key教程"></el-radio-button>
              <!-- <el-radio-button
                label="Binance 绑定API Key教程"
              ></el-radio-button> -->
            </el-radio-group>
          </div>
        </el-aside>
        <el-main class="course-body">
          <div class="main-content" v-if="BybitShow">
            <div class="article-header">Bybit 绑定API Key教程</div>
            <div class="article-body">
              <h3>第一步：获取API</h3>
              <p>1.登陆Bybit官网</p>
              <p>2.鼠标悬停在网页右上角头像处——点击下拉菜单栏中的【API】</p>
              <div class="article-img">
                <!-- <img src="@/assets/img/course/api.png" alt="" /> -->
                <viewer>
                  <img src="@/assets/img/course/api.png" width="800" />
                </viewer>
              </div>
              <p>3.点击【新建密匙】——选择【系统生成的API密钥】</p>
              <div class="article-img">
                <viewer>
                  <img src="@/assets/img/course/select.png" alt="" width="800" />
                </viewer>
              </div>
              <p>4.设置参数，权限——点击【提交】</p>
              <div class="article-img">
                <viewer>
                  <img src="@/assets/img/course/submit.png" alt="" width="800"/>
                </viewer>
              </div>
              <div class="article-body-module">
                <div>
                  <span>5.双重验证</span>
                  <div class="article-img">
                    <viewer>
                      <img src="@/assets/img/course/verification.png" alt="" width="380" />
                    </viewer>
                  </div>
                </div>
                <div style="margin-left: 40px">
                  <span>6.复制API信息</span>
                  <div class="article-img">
                    <viewer>
                      <img src="@/assets/img/course/copy.png" alt="" width="380" />
                    </viewer>
                  </div>
                </div>
              </div>
              <h3>第二步：在RTA中接入API</h3>
              <p>1.登陆RTA实盘中心【Center】</p>
              <p>
                2.鼠标悬停在网页右上角头像处——点击下拉菜单栏中的【实盘管理】
              </p>
              <div class="article-img">
                <viewer>
                  <img src="@/assets/img/course/rta-a.png" alt="" width="800" />
                </viewer>
              </div>
              <p>3.点击【接入实盘】</p>
              <div class="article-img">
                <viewer>
                  <img src="@/assets/img/course/rta-b.png" alt="" width="800" />
                </viewer>
              </div>
              <p>4.选择Bybit交易所——填写API信息——点击【绑定】——完成绑定</p>
              <div class="article-img">
                <viewer>
                  <img src="@/assets/img/course/rta-c.png" alt="" width="800" />
                </viewer>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
  
<script>
//import {  } from ''//

export default {
  data() {
    return {
      bourseRadio: 'Bybit 绑定API Key教程',
      BybitShow: true,
    };
  },
  created() {},
  mounted() {},
  methods: {
    BybitClick() {
      if (this.bourseRadio == 'Bybit 绑定API Key教程') {
        this.BybitShow =true;
      } else {
        this.BybitShow =false;
      }
    },
  },
};
</script>


<style lang="scss" scope>
.course-box {
  width: 1200px;
  margin: 40px auto !important;
  height: 100%;
  //text-align: center;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  .Breadcrumb {
    .el-breadcrumb {
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(209, 212, 220, 1);
          font-size: 14px;
          font-family: MicrosoftYaHei;
          line-height: 22px;
        }
        .el-breadcrumb__separator {
          font-size: 10px;
        }
      }
      .is-l {
        span {
          color: rgba(140, 140, 140, 1) !important;
        }
      }
    }
  }
  .bourse-container {
    width: 100%;
    height: 100%;
    margin-top: 60px !important;
    // .el-container:nth-child(5) .el-aside,
    // .el-container:nth-child(6) .el-aside {
    //   line-height: 260px;
    // }

    // .el-container:nth-child(7) .el-aside {
    //   line-height: 320px;
    // }
    .side-nav {
      color: #333;
      text-align: center;
      height: 100%;
      .sidebar-bnt {
        text-align: left;
        .el-radio-group {
          .el-radio-button {
            .el-radio-button__inner {
              background: transparent;
              border: none !important;
              font-size: 14px;
              font-family: DIN-Regular, DIN;
              font-weight: 400;
              color: #d1d4dc;
              padding: 5px 0 11px !important;
            }
            .el-radio-button__orig-radio:checked + .el-radio-button__inner {
              color: #fff;
              background-color: transparent;
              border-color: transparent !important ;
              font-size: 14px;
              font-family: DIN-Regular, DIN;
              font-weight: 400;
              color: #edbd88;
            }
          }
        }
        .el-button {
          margin: 0 0 11px;
          padding: 0;
          span {
            font-size: 14px;
            font-family: DIN-Regular, DIN;
            font-weight: 400;
            color: #d1d4dc;
          }
        }
      }
    }

    .course-body {
      color: #333;
      text-align: center;
      height: 100%;
      .main-content {
        font-size: 14px;
        font-family: DIN-Regular, DIN;
        font-weight: 400;
        color: #d1d4dc;
        text-align: left;
        .article-header {
          font-size: 20px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: #d1d4dc;
        }
        .article-body {
          margin-top: 40px;
          h3 {
            margin: 24px 0 !important;
          }
          .article-img {
            margin: 16px 0 40px;
          }
          p {
            // margin: 16px 0;
          }
          .article-body-module {
            display: flex;
            .article-img {
              margin: 16px 0 40px;
            }
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/course/course.vue